<template>
    <ProjectTable></ProjectTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ProjectTable = defineAsyncComponent(() =>
    import("../../components/GlobalPunchSystem/Projects/Table.vue")
);

export default {
    name: "Global_Punch_Employees", //The name you are in should not equal the name of the component you are importing.
    components: { ProjectTable, AuthLayout },
};
</script>
